import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=ee134838"
import script from "./collect.vue?vue&type=script&lang=js"
export * from "./collect.vue?vue&type=script&lang=js"
import style0 from "./collect.vue?vue&type=style&index=0&id=ee134838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports